import useAuth from '../useAuth/useAuth';

function useRolePermissions() {
  const { userData } = useAuth();
  /**
   * Checks if the user has role permissions for a certain kind of action/render
   * @param roles
   */
  const isUserAllowed = (roles?: string[]) => !!(userData && roles?.includes(userData.role));
  return { isUserAllowed };
}

export default useRolePermissions;
